import { useContext } from 'react';
import { TroubleShootingHandler } from '../../../../Pages/MainComponents/TroubleShooting/TroubleShooting';
import AudioService from '../../../../Services/AudioService';
import { RedoEasyFitContext, RedoEasyFitState } from '../RedoEasyFitContext';

function useRedoEasyFitTroubleShootingHandler(): TroubleShootingHandler {
    const { setRedoEasyFitState } = useContext(RedoEasyFitContext);

    const onStartAudioContext = async () => {
        await AudioService.serviceInstance.createNewAudioContext();
    };

    const onRetry = async () => {
        await onStartAudioContext();
        setRedoEasyFitState(RedoEasyFitState.OneSideSetUp);
    };

    return {
        onRetry,
    };
}

export default useRedoEasyFitTroubleShootingHandler;
